import { setHours } from 'date-fns';
import { OrderItem, Promotion, PromotionApplied } from '../apiTypes';

function calculateApplicablePromotions(
  promotions: DbDocument<Promotion>[],
  orderItems: OrderItem[],
  usedItemIds: Set<string> = new Set(),
  applicablePromotions: PromotionApplied[] = []
) {
  promotions.forEach((promotion) => {
    const startHoursTime = setHours(Date.now(), Number(promotion.startHours.split(':')[0])).setMinutes(
      Number(promotion.startHours.split(':')[1])
    );

    const endHoursTime = setHours(Date.now(), Number(promotion.endHours.split(':')[0])).setMinutes(
      Number(promotion.endHours.split(':')[1])
    );

    promotion.requiredDishes.forEach((requiredDishGroup) => {
      const matchedItems: OrderItem[] = [];
      let isGroupMatched = true;

      requiredDishGroup.items.forEach((requiredItem) => {
        const matchingOrderItems = orderItems.filter((orderItem) => {
          const availableByHours =
            startHoursTime < orderItem.addTime && (endHoursTime > orderItem.addTime || promotion.endHours === '00:00');
          return orderItem.dishId === requiredItem.dishId && !usedItemIds.has(orderItem.id) && availableByHours;
        });

        if (matchingOrderItems.length >= (Number(requiredItem.qnt) || 1)) {
          matchedItems.push(...matchingOrderItems.slice(0, Number(requiredItem.qnt) || 1));
        } else {
          isGroupMatched = false;
        }
      });

      if (isGroupMatched) {
        const matchedItemIds = matchedItems.map((item) => item.id);

        const discountSum =
          promotion.discountType === 'fixed_discount'
            ? Number(promotion.discountValue)
            : (matchedItems.reduce(
                (acc, item) =>
                  acc + (item.byWeight ? (Number(item.price) * 1000) / Number(item.defaultWeight) : Number(item.price)),
                0
              ) *
                Number(promotion.discountValue)) /
              100;

        matchedItemIds.forEach((id) => usedItemIds.add(id));
        applicablePromotions.push({
          promotionId: promotion.id,
          appliedForOrderItemIds: matchedItemIds,
          name: promotion.name,
          discountSum,
          discountType: promotion.discountType,
          discountValue: promotion.discountValue,
        });

        calculateApplicablePromotions([promotion], orderItems, usedItemIds, applicablePromotions);
      }
    });
  });

  return applicablePromotions;
}

export const getPromotionsApplied = (
  promotions: DbDocument<Promotion>[],
  orderItems: OrderItem[]
): PromotionApplied[] => {
  if (promotions.length === 0) {
    return [];
  }

  const timeNow = Date.now();
  const dayNow = new Date().getDay() === 0 ? '6' : String(new Date().getDay() - 1);

  const activePromotions = promotions.filter(
    (p) =>
      p.isActive &&
      p.startTime < timeNow &&
      p.endTime > timeNow &&
      p.days[dayNow as '0'] &&
      p.requiredDishes.every((b) => b.items.length > 0)
  );

  if (activePromotions.length === 0) {
    return [];
  }

  return calculateApplicablePromotions(activePromotions, orderItems);
};
